//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { connect } from "react-redux";
// chrome-mismatch imports
import * as styles from "./ChromeMismatch.styles";
import { IContainer, IProps, IState } from "./ChromeMismatchTypes";
// state
import { IReduxState } from "#webapp/src/state/reducers/root.reducer";
// other internals
import { asCard } from "#webapp/src/components/card";
import { PostMessageManager } from "#webapp/src/util/post-message.util";
// material-ui
import { Button } from "@material-ui/core";

//////////////////
// COMPONENT
//////////////////
export class ChromeMismatchComponent extends React.PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  private onClickClose = () => {
    PostMessageManager.closeSidebar(true);
  };

  public render() {
    const maybeCalendarMismatch =
      typeof this.props.calendarMismatch === "string" ? (
        <span>
          {" "}
          (<span style={styles.emphasized}>{this.props.calendarMismatch}</span>)
        </span>
      ) : null;

    return (
      <div style={styles.description}>
        <div>
          This Google account{maybeCalendarMismatch} is not signed in to Clockwise. Sign in to
          Clockwise with an account that has access to this Google account or you may also hide
          Clockwise from this view.
        </div>
        <Button variant="text" onClick={this.onClickClose} style={{ marginTop: 10 }}>
          Hide Extension
        </Button>
      </div>
    );
  }
}

//////////////////
// REDUX
//////////////////
function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {};
}

const reduxContainer = connect(mapStateToProps, {})(ChromeMismatchComponent);

//////////////////
// RELAY
//////////////////

export const ChromeMismatch = asCard<IContainer>(reduxContainer);
